import(/* webpackMode: "eager" */ "/home/coder/pubky-runtime/app-classic/src/app/error.tsx");
